import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';
import styles from './Badge.module.css';

export interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'success' | 'warning' | 'danger' | 'muted';
  dot?: boolean;
  /**
   * F-160 (B4): leading Lucide icon. Renders before `children` at 12px so it
   * sits flush with the label baseline.
   */
  icon?: IconName;
}

export function Badge({ children, variant = 'default', dot, icon }: BadgeProps): JSX.Element {
  const classes = [styles.badge, variant !== 'default' && styles[variant]].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      {dot ? <span className={styles.dot} /> : null}
      {icon ? <Icon name={icon} size={12} /> : null}
      {children}
    </span>
  );
}
